import { ActionReducerMap } from '@ngrx/store';
import * as fromHttp from './http.reducer';

export interface CoreState {
  readonly http: fromHttp.HttpState;
}

export const coreReducers: ActionReducerMap<CoreState> = {
  http: fromHttp.reducer,
};

export const CORE_FEATURE = 'core';
